<template>
  <b-form-group
    label="Situação do Agendamento"
    label-for="situacaoAgendamento"
    label-class="font_size_label situacaoAgendamento"
  >
    <validation-provider #default="{ errors }" name="Situação do Agendamento">
      <v-select
        id="situacaoAgendamento"
        :options="options"
        v-model="selected"
        placeholder="Selecione a Situação do Agendamento"
        label="descricao"
        :clearable="true"
        multiselect
        multiple
        :disabled="disabled"
      >
        <template #list-header v-if="ehMultiplo && options.length > 0">
          <div class="vs__dropdown-option" @click="toggleSelectAll">
            <input type="checkbox" class="mr-1" :checked="isAllSelected" @click.stop="toggleSelectAll"/>
            <span>Selecionar Todas</span>
          </div>
        </template>
        <span slot="no-options">Nenhuma opção selecionável.</span>
      </v-select>
      <small v-if="errors[0]" class="text-danger">
        {{ errors[0] }}
      </small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import {
  BForm,
  BCol,
  BRow,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BSpinner,
  BFormDatepicker,
  BFormTextarea,
  BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
  components: {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    value: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      selected: this.value,
    };
  },
  beforeMount() {
    this.options = [
      { descricao: "Agendado", situacao_cadastro: "Agendado" },
      { descricao: "Finalizado", situacao_cadastro: "Finalizado" },
      { descricao: "Cancelado", situacao_cadastro: "Cancelado" },
      { descricao: "Repescagem", situacao_cadastro: "Repescagem" },
    ];
  },

  methods: {
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selected = [];
      } else {
        this.selected = [...this.options];
      }
    },
  },

  watch: {
    selected: function (valor) {
      this.$emit("selected", valor);
    },
  },

  computed: {
    ehMultiplo() {
      return this.options.length > 1;
    },
    isAllSelected() {
      return this.selected && this.selected.length === this.options.length;
    }
  },
};
</script>

